module.exports = __webpack_public_path__ + "static/G2-Crowd-Rating-78ab16f071ac85c7c93f5a2b68bcced5.png";